import NotificationCard from './NotificationCard';

export default NotificationCard;



// WEBPACK FOOTER //
// ./src/components/NotificationCard/index.jsx